import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { EnquiryForm } from '../components/forms/EnquiryForm';

export default function RecrutementPage() {
  return <div className="min-h-screen bg-white">
    <Header />
    <main id="main-content" tabIndex={-1}>
      <section className="bg-[#E30022] text-white py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 data-testid="recruitment-page-title" className="text-4xl sm:text-5xl lg:text-6xl font-serif mb-4 break-words">Confiez-nous vos recrutements</h1>
          <p data-testid="recruitment-page-description" className="text-base sm:text-lg">Trouvez les talents qui feront la différence dans votre organisation.</p>
        </div>
      </section>
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <h2 data-testid="recruitment-form-title" className="text-base md:text-lg font-serif text-gray-800 mb-8">Décrivez votre besoin</h2>
        <EnquiryForm kind="recruitment" />
      </section>
    </main>
    <Footer />
  </div>;
}